import { useShowCampaignById_new } from '@givebacks/api/store';

import { CampaignStoreItemTypes } from '../types/utils';
import { useCampaignInfoByProvider } from './utils/campaignUtils';

const useShowCurrentCampaign = <T = CampaignStoreItemTypes>({
  select,
}: {
  select?: (data: CampaignStoreItemTypes) => T;
} = {}) => {
  const { causeId, campaignId } = useCampaignInfoByProvider();
  return useShowCampaignById_new({ campaignId, causeId, select });
};

export { useShowCurrentCampaign };
